export default {
  months(state) {
    const { monthlyRevenue = [] } = state || {};
    return monthlyRevenue.map(item => item.date);
  },
  dataValues(state) {
    const { monthlyRevenue = [] } = state || {};
    return monthlyRevenue.map(item => item.value);
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-monthly-revenue/store/getters.js